(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-seller"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var track = document.getElementById('bsc-track-{{ section.id }}');
    var fill  = document.getElementById('bsc-fill-{{ section.id }}');
    if (!track) return;

    /* ── Progress bar sync ── */
    function updateProgress() {
      if (!fill) return;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) { fill.style.width = '100%'; return; }
      var pct = (track.scrollLeft / max) * 100;
      fill.style.width = pct + '%';
    }

    track.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
    updateProgress();

    /* ── Click-drag to scroll ── */
    var isDragging = false;
    var startX, startLeft;

    track.addEventListener('mousedown', function (e) {
      isDragging = true;
      startX    = e.pageX;
      startLeft = track.scrollLeft;
      track.style.userSelect = 'none';
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      var delta = e.pageX - startX;
      track.scrollLeft = startLeft - delta;
    });

    document.addEventListener('mouseup', function () {
      isDragging = false;
      track.style.userSelect = '';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var grid = document.getElementById('comm-ig-grid-{{ section.id }}');
    var fill = document.getElementById('comm-ig-fill-{{ section.id }}');

    if (!grid) return;

    /* Progress bar */
    function updateBar() {
      if (!fill) return;
      var max = grid.scrollWidth - grid.clientWidth;
      if (max <= 0) { fill.style.width = '100%'; return; }
      fill.style.width = ((grid.scrollLeft / max) * 100) + '%';
    }

    grid.addEventListener('scroll', updateBar, { passive: true });
    window.addEventListener('resize', updateBar, { passive: true });
    updateBar();

    /* Drag-to-scroll */
    var drag = false, sx = 0, sl = 0;
    grid.addEventListener('mousedown', function (e) {
      drag = true; sx = e.pageX; sl = grid.scrollLeft;
      grid.style.userSelect = 'none';
    });
    document.addEventListener('mousemove', function (e) {
      if (!drag) return;
      grid.scrollLeft = sl - (e.pageX - sx);
    });
    document.addEventListener('mouseup', function () {
      drag = false; grid.style.userSelect = '';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
